var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"light-box"},[_c('cool-light-box',{attrs:{"items":_vm.images,"index":_vm.index,"useZoomBar":true,"enableScrollLock":false},on:{"close":function($event){return _vm.$emit('close')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }